import React from 'react'
import LoginPage from './LoginPage'
import NotFoundPage from './NotFoundPage'
import DealersPage from './Dealers/List/DealersPage'
import DealersAddPage from './Dealers/Add/DealersAddPage'
import DealersEditPage from './Dealers/Edit/DealersEditPage'
import MultiFactorPage from './MultiFactorPage'
import OpenInvoicesPage from './Reports/Finance/OpenInvoicesPage'
import OpenInvoiceBucketsPage from './Reports/Finance/OpenInvoiceBucketsPage'
import SignUpEditPage from './SignUp/Edit/SignUpEditPage'
import SignUpAddPage from './SignUp/Add/SignUpAddPage'
import CMSCachePage from './Integrations/Cache/CMSCachePage'
import TestRailsPage from './Integrations/TestRails/TestRailsPage'
import MerchantsPage from './Integrations/Merchants/List/MerchantsPage'
import MerchantsAddPage from './Integrations/Merchants/Add/MerchantsAddPage'
import FreeMonthsByRepByMonthPage from './Reports/Sales/FreeMonthsByRepByMonthPage'
import ApplicationLogsPage from './Logs/ApplicationLogsPage'
import ApplicationLogsDetailsPage from './Logs/ApplicationLogsDetailsPage'
import KnownIssuesPage from './Integrations/KnownIssues/KnownIssuesPage'
import KnownIssuesAddPage from './Integrations/KnownIssues/Add/KnownIssuesAddPage'
import KnownIssuesEditPage from './Integrations/KnownIssues/Edit/KnownIssuesEditPage'
import LoginSettingsPage from './MyProfile/LoginSettingsPage'
import SystemInformationPage from './Integrations/SystemInformation/SystemInformationPage'
import WebsiteLeadsFilterPage from './Integrations/WebsiteLeadsFilter/WebsiteLeadsFilterPage'
import WebsiteLeadsFilterAddPage from './Integrations/WebsiteLeadsFilter/Add/WebsiteLeadsAddPage'
import WebsiteLeadsFilterEditPage from './Integrations/WebsiteLeadsFilter/Edit/WebsiteLeadsEditPage'
import CasesPage from './Cases/CasesPage'
import CasesAddPage from './Cases/Add/CasesAddPage'
import CasesEditPage from './Cases/Edit/CasesEditPage'
import OfferUpSalesPage from './Reports/Accounting/OfferUpSalesPage'
import TestDriveRewardsSalesPage from './Reports/Accounting/TestDriveRewardsSalesPage'
import CancellationReportPage from './Reports/CustomerService/CancellationReportPage'
import SMSPage from './Integrations/SMS/SMSPage'
import SMSAddPage from './Integrations/SMS/SMSAddPage'
import SMSEditPage from './Integrations/SMS/SMSEditPage'
import MigrationToolPage from './Integrations/MigrationToolPage'
import F4SettingsPage from './Integrations/F4SalesEngine/F4SettingsPage'
import F4DataSyncQueuePage from './Integrations/F4DataSyncQueuePage'
import AudioEyePage from './Integrations/AudioEye/AudioEyePage'
import AudioEyeAddPage from './Integrations/AudioEye/Add/AudioEyeAddPage'
import AudioEyeEditPage from './Integrations/AudioEye/Edit/AudioEyeEditPage'

export interface IPageComponent {
    name: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: React.FC<any>;
}

const pageArray: Array<IPageComponent> =
    [
        { name: 'LoginPage', component: LoginPage },
        { name: 'NotFoundPage', component: NotFoundPage },
        { name: 'DealersPage', component: DealersPage },
        { name: 'DealersAddPage', component: DealersAddPage },
        { name: 'DealersEditPage', component: DealersEditPage },
        { name: 'MultiFactorPage', component: MultiFactorPage },
        { name: 'OpenInvoicesPage', component: OpenInvoicesPage },
        { name: 'OpenInvoiceBucketsPage', component: OpenInvoiceBucketsPage },
        { name: 'SignUpAddPage', component: SignUpAddPage },
        { name: 'SignUpEditPage', component: SignUpEditPage },
        { name: 'CMSCachePage', component: CMSCachePage },
        { name: 'TestRailsPage', component: TestRailsPage },
        { name: 'MerchantsPage', component: MerchantsPage },
        { name: 'MerchantsAddPage', component: MerchantsAddPage },
        { name: 'FreeMonthsByRepByMonthPage', component: FreeMonthsByRepByMonthPage },
        { name: 'ApplicationLogsPage', component: ApplicationLogsPage },
        { name: 'ApplicationLogsDetailsPage', component: ApplicationLogsDetailsPage },
        { name: 'KnownIssuesPage', component: KnownIssuesPage },
        { name: 'KnownIssuesAddPage', component: KnownIssuesAddPage },
        { name: 'KnownIssuesEditPage', component: KnownIssuesEditPage },
        { name: 'LoginSettingsPage', component: LoginSettingsPage },
        { name: 'SystemInformationPage', component: SystemInformationPage },
        { name: 'WebsiteLeadsFilterPage', component: WebsiteLeadsFilterPage },
        { name: 'WebsiteLeadsFilterAddPage', component: WebsiteLeadsFilterAddPage },
        { name: 'WebsiteLeadsFilterEditPage', component: WebsiteLeadsFilterEditPage },
        { name: 'CasesPage', component: CasesPage },
        { name: 'CasesAddPage', component: CasesAddPage },
        { name: 'CasesEditPage', component: CasesEditPage },
        { name: 'OfferUpSalesPage', component: OfferUpSalesPage },
        { name: 'TestDriveRewardsSalesPage', component: TestDriveRewardsSalesPage },
        { name: 'CancellationReportPage', component: CancellationReportPage },
        { name: 'F4SettingsPage', component: F4SettingsPage },
        { name: 'SMSPage', component: SMSPage },
        { name: 'SMSAddPage', component: SMSAddPage },
        { name: 'SMSEditPage', component: SMSEditPage },
        { name: 'MigrationToolPage', component: MigrationToolPage },
        { name: 'F4DataSyncQueuePage', component: F4DataSyncQueuePage },
        { name: 'AudioEyePage', component: AudioEyePage },
        { name: 'AudioEyeAddPage', component: AudioEyeAddPage },
        { name: 'AudioEyeEditPage', component: AudioEyeEditPage },
    ]
export default pageArray
